import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  TextField,
  Snackbar,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { Timestamp } from "firebase/firestore";
import useFirestore from "../../../../config/fireBaseHook";
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const Add = ({ onRecordAdded }) => {
  const { addData } = useFirestore("CreditCaptureStatus");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [formData, setFormData] = useState({
    Credit_Capture_Status: "",
    Active: -1, // Default to Active
  });
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!formData.Credit_Capture_Status.trim()) {
      newErrors.Credit_Capture_Status = "Credit Capture Status is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "Active" ? parseInt(value) : value,
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      const dataToAdd = {
        ...formData,
      };

      await addData(dataToAdd);
      setLoading(false);
      setSnackbarOpen(true);
      setFormData({
        Credit_Capture_Status: "",
        Active: -1,
      });
      setErrors({});
      setOpen(false);
      onRecordAdded();
    } catch (error) {
      console.error("Error adding record:", error);
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({
      Credit_Capture_Status: "",
      Active: -1,
    });
    setErrors({});
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <div>
      <Button
        variant="contained"
        color="success"
        onClick={() => setOpen(true)}
        sx={{ marginBottom: "10px", color: "white" }}
      >
        Add Record
      </Button>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <ModalDialogTitle onClose={handleClose}>
          Add Credit Capture Status
        </ModalDialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Credit Capture Status"
                name="Credit_Capture_Status"
                value={formData.Credit_Capture_Status}
                onChange={handleChange}
                fullWidth
                margin="normal"
                required
                error={!!errors.Credit_Capture_Status}
                helperText={errors.Credit_Capture_Status}
              />
              <FormControl fullWidth margin="normal" required>
                <InputLabel id="active-label">Active</InputLabel>
                <Select
                  labelId="active-label"
                  name="Active"
                  value={formData.Active}
                  onChange={handleChange}
                  label="Active"
                >
                  <MenuItem value={-1}>Active</MenuItem>
                  <MenuItem value={0}>Inactive</MenuItem>
                </Select>
                <FormHelperText>
                  Select whether this credit capture status is active or
                  inactive
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <ModalActions onSave={handleSubmit} saving={loading} />
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message="Record has been added"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        ContentProps={{
          sx: {
            backgroundColor: "black",
            color: "white",
          },
        }}
      />
    </div>
  );
};

export default Add;
